import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Home';
import HamburgerMenu from './HamburgerMenu';
import { ThemeProvider } from './ThemeContext';
import { LanguageProvider } from './LanguageContext';
import Contacto from './Contacto';
import Footer from './Footer';



 function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <Router>
          <HamburgerMenu />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contacto" element={<Contacto />} />
          </Routes>
          <Footer />
        </Router>
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
